const persons = {
  title: "Persons",
  new_person: "New Person",
  edit_person: "Edit Person: {name}",
  view_person: "View Person: {name}",
  person_title: "Person Details",
  list_title: "List of Persons",
  list_subtitle: "Manage persons",
  overview: "Expertise",
  qrcode_title: "QR Code",
  id: "ID",
  first_name: "First Name",
  last_name: "Last Name",
  middle_name: "Middle Name",
  mobile: "Mobile Phone",
  email: "Email Address",
  date_of_birth: "Date of Birth",
  comments: "Comments",
  create_as_user: "Create as User",
  employeed_from: "Employeed From",
  employed_to: "Employed To",
  dob: "DOB",
  company: "Company",
  street: "Street",
  city: "City",
  state: "State",
  zip: "Zip",
  country: "Country",
  image: "Image",
  upload_image: "Upload Image",
  select_image: "Select image to upload",
  last_updated_sync: "Last date updated/synced",
  qr_generate: "Generate QR Code",
  student_1_image: "Use student 1 image",
  student_2_image: "Use student 2 image",
  merge_to_existing: "Merge to existing student",
  merge_th_field: "Field",
  merge_existing_user: "Existing Student",
  merge_new_user: "New Student",
  merge_th_result: "Result",
}
export default persons
